module.exports = __webpack_public_path__ + "static/media/wl.c1861e22.png";